

// ios 浏览器
export function isIosBrowser() {
  return getMobileOperatingSystem() === "IOS";
}

export const getImageUrlFn = (path) => {
  const { currtAssertApi } = useGlobalStore()
  // if (location.port == '3000' || location.origin.includes('localhost')) {
  //   return path
  // }
  return currtAssertApi?.url + path
}


// canvas检测
export function isSupportWebp() {
  try {
    const img = document.createElement('canvas');
    const imgData = img.toDataURL('image/webp', 0.5)
    return imgData.indexOf('data:image/webp') === 0;
  } catch (err) {
    return false;
  }
}


// .jpg', '.jpeg', '.png', '.bmp', '.webp', '.gif', '.tiff' 生产类型
export function getWebPImg(src) {
   const { curAdvDomain,curVideoImageDomain } = storeToRefs(useGlobalStore())
  if (src?.includes(curAdvDomain.value?.url) || src?.includes(curVideoImageDomain.value?.url)) {
    let srcArr = src?.split('.')
    const type = srcArr.pop()?.split('?')?.[0]?.toLocaleLowerCase()
    srcArr = srcArr?.join('.')
    if (['gif', 'svg', 'js']?.includes(type)) {
      return srcArr + '.js'
    }
    if (isSupportWebp()) {
      return srcArr + '.w.js'
    } else {
      return srcArr + '.js'
    }
  }
  return src
}


// android 浏览器
export function isAndroidBrowser() {
  return getMobileOperatingSystem() === 'Android'
}

export function hasApiUrl() {
  const appInfo = appAgentParams()
  return !!appInfo.apiurl
}

// android app
export function isAndroid() {
  return isAndroidBrowser() && hasApiUrl()
}

//将接收的对象数据转为请求url接口参数
export function useQueryToString(query = {}) {
  let q = ''
  for (const key in query) {
    if (q == '') {
      q = `?${key}=${query[key]}`
    } else {
      q += `&${key}=${query[key]}`
    }
  }
  return q
}
/**
 * 手机号码脱敏
 * @param number
 */
export function phoneNuberConvert(number) {
  if (!number) return ''
  let pat = /(\d{3})\d*(\d{4})/
  let result = number.replace(pat, '$1***$2')
  return result
}

export function phoneNuberConvertGay(number) {
  if (!number) return ''
  let pat = /(\d{3})\d*(\d{2})/
  let result = number.replace(pat, '$1***$2')
  return result
}

//回车事件
export function useEnterEvent(event) {
  let handleEnterEvent = (e) => {
    if (e.key === 'Enter') {
      event()
      e.preventDefault()
    }
  }
  onBeforeMount(() => {
    document.addEventListener('keydown', handleEnterEvent)
  })

  //移除事件
  onUnmounted(() => {
    document.removeEventListener('keydown', handleEnterEvent)
  })
}

//时间状态判断
export function useTimeStatus(start, end) {
  start = new Date(start).getTime()
  end = new Date(end).getTime()
  const now = Date.now()

  let status = ''
  if (start < now && now < end) {
    status = 'ing'
  } else if (start >= now) {
    status = 'pending'
  } else {
    status = 'end'
  }

  return status
}

/***
 * @param time 13位时间戳 || date字符串（能转化成new Date的数据均可）
 * @param fmt 转化格式
 * @returns {string} 转换后的字符串
 */
export function dateFormat(time, fmt = 'yyyy-MM-dd hh:mm:ss') {
  if (!time) {
    return ''
  }
  const date = new Date(time)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').slice(4 - RegExp.$1.length))
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, str.padStart(RegExp.$1.length, '0'))
    }
  }
  return fmt
}

export function isValidURL(url) {
  const regex = /^(https?):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]$/
  return regex.test(url)
}

export function getPlatform() {
  if (process.client) {
    const isIOSWebView =
      !!window.webkit && !!window.webkit.messageHandlers && window.webkit.messageHandlers.openThirdWeb
    const isAndroidWebView = !!window.android
    const isWebStand = !!window.navigator.standalone

    if (isWebStand || isIOSWebView) {
      return 1 // iOS
    } else if (isAndroidWebView) {
      return 0 // Android
    } else {
      return 2 // H5 (Web)
    }
  }
}
export function convertTimeToSeconds(timeStr) {
  const [hours, minutes, seconds] = timeStr.split(':').map(Number)
  return hours * 3600 + minutes * 60 + seconds
}
export function isWebView() {
  const isIOSWebView =
    !!window.webkit && !!window.webkit.messageHandlers && !!window.webkit.messageHandlers.openThirdWeb
  const isAndroidWebView = !!window.android

  return !!(isIOSWebView || isAndroidWebView)
}

export function isSafariHandle() {
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.includes("safari") &&
    !ua.includes("chrome") &&
    !ua.includes("crios") &&
    !ua.includes("fxios") &&
    !ua.includes("edg")
  );
}
export const orgClearkeyVersion = 'org.w3.clearkey';

// Hex 转 Base64URL
export function hexToBase64Url(hex) {
  const bytes = new Uint8Array(hex.match(/.{2}/g).map(b => parseInt(b, 16)));
  let binary = '';
  bytes.forEach(b => binary += String.fromCharCode(b));
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
// 获取操作系统
export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  if (/android/i.test(userAgent)) {
    return 'Android'
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'IOS'
  }

  return 'unknown'
}

export function initCaptcha() {
  const scriptList = [`${window.currtAssertApi}/js/TCaptcha.js`]
  if (process.client) {
    // @ts-ignore
    if (!window.TencentCaptcha) {
      useHead({
        script: scriptList.map((scriptStr) => ({
          src: scriptStr,
          async: true
          // defer: true
        }))
      })
    }
  }
}

// 是否是Json
export function isJSON(str) {
  try {
    const obj = JSON.parse(str)
    if (obj && typeof obj === 'object') {
      return true
    }
  } catch (err) {
    return false
  }
  return false
}

// 本地开发 配置
export function isLocalBuild() {
  return import.meta.env.DEV
}

export function appAgentParams() {
  const param = {
    origindomain: '',
    apiurl: '',
    version: '',
    deviceid: '',
    publicKey: '',
    firstInstall: ''
  }

  if (!isLocalBuild()) {
    const userAgent = navigator.userAgent
    const splitArr = userAgent.split('MyUserAgent=')
    if (splitArr.length === 2) {
      if (isJSON(splitArr[1])) {
        const appInfo = JSON.parse(splitArr[1])
        param.apiurl = appInfo?.apiurl
        param.origindomain = appInfo?.origindomain
        param.version = appInfo?.version
        param.deviceid = appInfo?.deviceid
        param.publicKey = appInfo?.PUBLIC_KEY
        param.firstInstall = appInfo?.firstInstall
      }
    }
  }
  return param
}

export function appAgentParams2() {
  const param = {
    origindomain: '',
    apiurl: '',
    version: '',
    deviceid: '',
    publicKey: '',
    firstInstall: '',
    code: ''
  }
  const userAgent = navigator.userAgent
  const splitArr = userAgent.split('MyUserAgent=')
  if (splitArr.length === 2) {
    if (isJSON(splitArr[1])) {
      const appInfo = JSON.parse(splitArr[1])
      param.apiurl = appInfo?.apiurl
      param.origindomain = appInfo?.origindomain
      param.version = appInfo?.version
      param.deviceid = appInfo?.deviceid
      param.publicKey = appInfo?.PUBLIC_KEY
      param.firstInstall = appInfo?.firstInstall
      param.code = appInfo?.code
    }
  }
  return param
}

//获取渠道code
export function channelCode() {
  const deviceType = getPlatform()
  const appInfo = appAgentParams2()
  const userAgent = navigator.userAgent
  // ios
  if (deviceType == 1) {
    const splitArr = userAgent.split('code=')
    if (splitArr.length == 2) {
      return splitArr[1]
    }
  }
  // 安卓
  if (deviceType == 0) {
    return appInfo.code
  }
  // 其他
  // return getQueryVariable("code");
  // return window?.appConfigCopy?.sourceCode
  return ''
}

export function copyToClipboard(text) {
  // 创建一个临时的textarea元素
  var textArea = document.createElement('textarea')

  // 隐藏这个元素
  textArea.style.position = 'fixed'
  textArea.style.top = '0'
  textArea.style.left = '0'
  textArea.style.width = '2em'
  textArea.style.height = '2em'
  textArea.style.padding = '0'
  textArea.style.border = 'none'
  textArea.style.outline = 'none'
  textArea.style.boxShadow = 'none'
  textArea.style.background = 'transparent'

  // 将文本赋值给textarea元素
  textArea.value = text

  // 将textarea元素添加到body
  document.body.appendChild(textArea)

  // 选中textarea内容
  textArea.select()

  // 执行复制命令
  document.execCommand('copy')

  // 移除textarea元素
  document.body.removeChild(textArea)
}

export function phoneReg(str) {
  const reg = /^1[123456789]\d{9}$/
  return reg.test(str)
}
export function getVideoImageUrl(url) {
  const { appData } = useGlobalStore()
  if (!url) return ''
  // Filter resource domains with category === 1
  const resourceDomains = appData.resourceDomains.filter((domain) => domain.category === 1)

  // Define a default domain in case no matching domains are found
  const defaultDomain = ''

  // Select a random domain from the filtered list or use the default domain
  const randomDomain =
    resourceDomains.length > 0 ? resourceDomains[Math.floor(Math.random() * resourceDomains.length)].url : defaultDomain

  // Ensure there is exactly one slash between the domain and the URL path
  const formattedDomain = randomDomain.replace(/\/+$/, '')
  const formattedUrl = url.replace(/^\/+/, '')

  return `${formattedDomain}/${formattedUrl}`
}

export function filterResourceDomainsByCategory(category) {
  const { appConfig } = storeToRefs(useGlobalStore())
  if(appConfig.value?.resourceDomains && appConfig.value?.resourceDomains?.filter){
    return appConfig.value?.resourceDomains?.filter((r) => r.category === category && isValidURL(r?.url)) || []
  }
  return []
}
// 定义获取图片地址的方法 public目标
export function getProjectImageUrl(fileRoot, fileName) {
  const { theme } = storeToRefs(useGlobalStore())
  const filePath = '/' + fileRoot + '/' + theme.value + '/' + fileName
  const isAndroidWebView = !!window.android
  if (isAndroidWebView) {
    return '.' + filePath
  }
  return filePath
}
export const getImageUrl = (path) => {
  const { currtAssertApi } = useGlobalStore()
  // console.log(currtAssertApi);
  // if (location.port == '3000' || location.origin.includes('localhost')) {
  //   return path
  // }
  return currtAssertApi?.url + path
}

export function cleanDomain(domain) {
  domain = domain?.replace(/(https?:\/\/)/, '')
  return domain?.endsWith('/') ? domain.slice(0, -1) : domain
}

export function parsePageCount(str) {
  if (!str) {
    return 0
  } else {
    const cleanedStr = str?.replace('0, ', '')
    const arr = cleanedStr?.split(',').map((item) => Number(item))
    return arr?.length - 1
  }
}

export function generateMockData() {
  const mockData = []
  const titles = [
    '小仙女推荐古风歌曲22.mp4',
    '中国古风歌曲 🌹 .mp4',
    '345.mp4',
    '2024-03-01_14-02-49.mp4',
    '1会话列表同时多个会话接收新消息.mp4'
  ]
  const createUserNames = ['dudu1', 'dudu2', 'dudu3']
  const tagIds = [[37], [37], [37], [37], [1]]
  const qualities = [
    [700, 1200],
    [200, 1200],
    [200, 1200],
    [200, 1200],
    [700, 1200]
  ]

  for (let i = 0; i < 5; i++) {
    mockData.push({
      id: (1854042294571778049 + i).toString(),
      mainImgUrl: `20241106/${Math.random().toString(36).substring(2, 10)}/image/${Math.random()
        .toString(36)
        .substring(2, 32)}.webp`,
      title: titles[i],
      previewUrl: `20241106/${Math.random().toString(36).substring(2, 10)}/preview/preview.mp4`,
      createTime: new Date(2024, 10, 6 + i, 16, 41, 11 + i).toISOString(),
      createUserName: createUserNames[i % createUserNames.length],
      tagIds: tagIds[i],
      duration: `00:${Math.floor(Math.random() * 60)
        .toString()
        .padStart(2, '0')}:${Math.floor(Math.random() * 60)
        .toString()
        .padStart(2, '0')}`,
      view: Math.floor(Math.random() * 10) + 1,
      hot: null,
      quality: qualities[i]
    })
  }

  return mockData
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
